<script>
  /**
   * @type {string}
   */
  export let color = "#1C1C20";
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M11.988 20.6998C10.7889 20.6998 9.66188 20.4706 8.60705 20.0123C7.55238 19.554 6.63297 18.9337 5.8488 18.1516C5.06447 17.3694 4.44363 16.4496 3.9863 15.3923C3.5288 14.335 3.30005 13.2052 3.30005 12.0031C3.30005 10.8009 3.52838 9.67014 3.98505 8.61081C4.44188 7.55147 5.0618 6.63005 5.8448 5.84655C6.6278 5.06289 7.54855 4.44255 8.60705 3.98555C9.66555 3.52839 10.7965 3.2998 12 3.2998C13.0055 3.2998 13.957 3.45814 14.8543 3.7748C15.7515 4.09147 16.5667 4.53314 17.3 5.0998L16.8 5.6248C16.1334 5.10814 15.3935 4.70814 14.5805 4.4248C13.7677 4.14147 12.9075 3.9998 12 3.9998C9.78338 3.9998 7.89588 4.77897 6.33755 6.3373C4.77922 7.89564 4.00005 9.78314 4.00005 11.9998C4.00005 14.2165 4.77922 16.104 6.33755 17.6623C7.89588 19.2206 9.78338 19.9998 12 19.9998C12.6 19.9998 13.1834 19.9331 13.75 19.7998C14.3167 19.6665 14.8584 19.4831 15.375 19.2498L15.9001 19.7748C15.3167 20.0748 14.6959 20.304 14.0375 20.4623C13.3792 20.6206 12.696 20.6998 11.988 20.6998ZM19.6501 19.3498V16.3498H16.6501V15.6498H19.6501V12.6498H20.35V15.6498H23.35V16.3498H20.35V19.3498H19.6501ZM10.55 15.6998L7.20005 12.3498L7.70005 11.8498L10.55 14.6998L20.2001 5.0498L20.7001 5.5498L10.55 15.6998Z"
    fill={color}
  />
</svg>
